/* Core & libraries */
import React, { useState, useEffect } from 'react';
import { useTheme } from 'react-jss';

/* Components */
import UCModal from 'components/ucmodal';
import SpinnerBasic from 'components/spinners/SpinnerBasic';

/* Styles */
import styles from './styles';

const IframeModal = ({ selectedUrl, setSelectedUrl, dataTestId }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
  }, [selectedUrl]);

  return (
    <UCModal
      className={classes.modal}
      showModal={!!selectedUrl}
      setShowModal={() => setSelectedUrl(null)}
      modalContent={
        <div className={classes.iframeContainer}>
          {!isLoaded && <div className={classes.spinnerOverlay}><SpinnerBasic /></div>}
          <iframe
            src={selectedUrl}
            className={classes.iframe}
            title="Support Form"
            onLoad={() => setIsLoaded(true)}
          />
        </div>
      }
      dataTestId={dataTestId}
    />
  );
};

export default IframeModal;
